<template>
  <div class="">
    <div class="mgb80">
      <div class="content-web">
        <div class="inner_content_right">
          <div class="wp_single wp_column_article">
            <div class="wp_entry">
              <div class="wp_articlecontent">
                <div class="head">
                  <div class="lsd">天津北方人才港股份有限公司</div>
                  <p class="p1">
                    天津北方人才港股份有限公司成立于2001年，专业从事高端人力资源相关服务，公司注册资金3280万元，拥有“第一资源”著名品牌，致力于打造“高端人才服务高地”，公司经过二十年的发展，形成了专项招聘、高端猎头、人才测评、管理咨询、人才培训以及人才信息化服务等人力资源全产业链服务体系。
                  </p>
                  <div class="p1">
                    公司拥有数十万人才信息资源，以八大支柱型产品为依托，将传统人力资源理念与现代服务模式嫁接，在人力资源服务全面信息化平台的基础上，实现集团化、高端化、专业化、多元化发展。
                  </div>
                  <div class="p1">
                    公司服务对象从天津辐射华北乃至全国，与多个省市的企事业单位建立了良好的长期战略合作关系。我们以专业化的服务水平、敬业的服务精神被广大客户所认可，成为国家级人力资源重点服务机构，位居中国人才产业市场最具影响力的专业型服务机构前列。
                  </div>
                  <div class="p1">
                    公司将继续以“人才为本，诚信至上，创新不止，竞争取胜”为经营理念，充分发挥国有大型人力资源服务机构的功能，为我国进一步实施全面深化改革的各项建设提供强有力的人才支持和智力保障。
                  </div>
                  <div class="p1">网址：www.caso.com.cn</div>
                  <div class="img1">
                    <img src="@/assets/images/bfrc.png" alt="" height="450px" width="100%" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.mgb80 {
  margin-bottom: 80px;
  margin-top: 30px;
  .content-web {
    display: flex;
    width: 100%;
    // min-width: 1200px;
    margin: 0 auto;
    .inner_content_right {
      // float: right;
      //   box-sizing: border-box;
      //   width: 960px;
      //   min-height: 600px;
      //   margin-left: 20px;
      //   background-color: #fff;
      .wp_single.wp_column_article {
        padding: 48px 40px 100px 40px;
      }
      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;;
        .head {
          border-bottom: 1px #444 dashed;
          height: 100%;
          .lsd {
            font-size: 20px;
            text-align: center;
            font-weight: 800;
            margin-bottom: 20px;
          }
          .p1 {
            text-indent: 35px;
            margin-bottom: 20px;
          }
          .p2 {
            text-indent: 35px;
            margin-bottom: 20px;
          }
          .img1 {
            text-align: center;
            margin-bottom: 20px;
          }
        }
      }
      .text {
        text-indent: 35px;
      }
      .ltd {
        float: right;
      }
    }
  }
}
</style>